import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Experience from '../components/Experience';
import Education from '../components/Education';
import Media from '../components/Media';
import Contact from '../components/Contact';

const Home = () => {
    return (
        <main>
            <Hero />
            <div className="container py-5 lg-stack">
                <About />
                <Experience />
                <Education />
                <Media />
                <Contact />
            </div>
        </main>
    );
};

export default Home;
